<template>
    <modal :show="show_final_modal" :closable="!loading" @close="$emit('done_loading')">

        <div slot="header">
            <div class="modal-header">
                <h5 class="modal-title" v-if="ceremony && !isLiteVersion">{{ ceremony.translated_type }} {{ $t('ceremony.submit_to_company', { company: companySettings?.name }) }}</h5>
                <h5 class="modal-title" v-if="ceremony && isLiteVersion">{{ ceremony.translated_type }} {{ $t('ceremony.submit') }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
        </div>

        <div slot="body">

            <div class="text-center" v-if="loading">
                <div class="spinner-border" role="status">
                    <span class="sr-only">{{ $t('general.loading') }}</span>
                </div>
            </div>

            <div v-if="!loading && ceremony">
                <div class="alert alert-danger" v-for="error of status.errors" :key="error.message">
                    <strong>{{ error.message }}</strong>
                    <div v-if="error.blocks && error.blocks.length">{{ getBlockNames(error.blocks).join(', ') }}</div>
                </div>

                <div class="alert alert-info" v-for="warning of status.warnings" :key="warning.message">
                    <strong>{{ warning.message }}</strong>
                    <p v-if="warning.message === $t('ceremony.upload_incomplete_warning')">{{ $t('ceremony.upload_incomplete_warning') }}</p>
                    <p v-if="warning.message === $t('files.files_with_low_quality')">
                        {{ $t('ceremony.quality_warning') }}
                    </p>
                    <div v-if="warning.blocks && warning.blocks.length">{{ getBlockNames(warning.blocks).join(', ') }}</div>
                </div>

                <div v-if="!status.errors.length">
                    <p>{{ $t('ceremony.cant_change_ceremony_after_submit_warning') }}</p>
                    <div v-html="companySettings?.submit_info"></div>
                </div>

                <div>
                    <p>
                        {{ $t('ceremony.notes') }}
                        <sup>
                            <icon name="question-circle" v-tooltip="$t('ceremony.notes_tooltip')" />
                        </sup>
                    </p>

                    <Editor
                        v-model="ceremony.notes"
                    />
                </div>
            </div>

        </div>

        <div slot="footer">
            <button type="button" class="btn btn-success btn-sm" @click="submitCeremony()" :disabled="loading || status.errors.length >= 1">
                <icon name="upload" scale="0.8"></icon>
                {{ !isLiteVersion ? $t('ceremony.submit_to_company', { company: companySettings?.name }) : $t('ceremony.submit') }}
            </button>
            <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="$emit('done_loading')">
                {{ $t('general.close') }}
            </button>
        </div>
    </modal>
</template>

<script>
    import Modal from "../../components/Modal";
    import {mapState} from 'vuex';
    import Editor from '../components/Editor.vue';

    export default {

        components: {
            Modal,
            Editor,
        },

        props: {
            show_final_modal: {
                type: Boolean,
                required: false,
                default: false,
            },
        },

        computed: {
            isLiteVersion() {
                return !!window.IS_LITE_VERSION;
            },

            ...mapState({
                ceremony: state => state.ceremony,
                companySettings: state => state.companySettings,
            })
        },

        data() {
            return {
                loading: false,
                blocks: [],
                status: {
                    errors: [],
                    warnings: []
                },
            }
        },

        watch: {
            show_final_modal() {
                if (!this.show_final_modal) {
                    return;
                }

                this.getCeremony();
            }
        },

        methods: {
            getBlockNames(blockIds) {
                return this.blocks.filter(block => blockIds.indexOf(block.id) !== -1).map(block => block.name);
            },

            async getCeremony() {
                this.loading = true;

                try {
                    const response = await this.$http.get(`/api/ceremonies/code/${this.ceremony.code}`);

                    this.status = response.data.status;
                    this.blocks = response.data.blocks;
                } catch (exception) {
                    console.log(exception);
                    console.log('getCeremony error');
                }

                this.loading = false;
            },

            async submitCeremony() {
                this.loading = true;

                try {
                    await this.$http.post(`/api/ceremonies/code/${this.ceremony.code}/submit`, {
                        notes: this.ceremony.notes,
                    });

                    this.$notify({
                        group: 'default',
                        title: this.$t('ceremony.submitted_title', { type: this.ceremony.translated_type }),
                        text: this.$t('ceremony.submitted_message', { type: this.ceremony.translated_type }),
                        type: 'success',
                        duration: 2500,
                        position: 'top center',
                    });


                } catch (exception) {
                    console.log(exception);
                    console.log('submitCeremony error');
                }

                this.$store.dispatch('getCeremony', this.$route.params.code);
                this.$emit('done_loading');
                this.loading = false;
            },
        }
    }
</script>

<style scoped>
    .alert strong {
        font-size: 15px;
    }
</style>
